<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-swim-ring`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm-5.21 30.538l-5.746 5.745A17.921 17.921 0 0024 42c4.122 0 7.921-1.386 10.956-3.717l-5.747-5.745A9.953 9.953 0 0124 34a9.953 9.953 0 01-5.21-1.462zM6 24a17.93 17.93 0 004.16 11.51l5.7-5.699A9.955 9.955 0 0114 24a9.95 9.95 0 011.462-5.209l-5.746-5.746A17.921 17.921 0 006 24zm32.284-10.955l-5.746 5.746A9.953 9.953 0 0134 24c0 2.167-.69 4.173-1.86 5.811l5.7 5.7A17.927 17.927 0 0042 24c0-4.122-1.386-7.92-3.716-10.955zM24 18a6 6 0 100 12 6 6 0 000-12zm0-12c-4.377 0-8.39 1.562-11.51 4.16l5.699 5.7A9.955 9.955 0 0124 14c2.167 0 4.174.69 5.811 1.86l5.699-5.7A17.927 17.927 0 0024 6z"/></svg>
</template>
<script>

export default {
  name: 'IconSwimRing',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
